import * as React from 'react';
import useStyles from './Auth0Modal.styles';
import { Clickable, Icon, Typography } from '../../atoms';
import { useState } from 'react';
import { Auth0MockStaticLoginInstructions } from '../Auth0MockStaticLoginInstructions';

export interface IAuth0ModalProps {
  isModalOpen: boolean;
  modalContent: {
    title: React.ReactNode;
    image: string;
    content: React.ReactNode;
  };
  onClose: () => void;
}

const Auth0Modal: React.FC<IAuth0ModalProps> = ({
  isModalOpen,
  modalContent,
  onClose,
}) => {
  const classes = useStyles();
  const [isClosing, setIsClosing] = useState(false);
  if (!isModalOpen) {
    return null;
  }
  return (
    <section className={!isClosing ? classes.root : classes.rootReverse}>
      <article
        className={
          !isClosing ? classes.modalContent : classes.modalContentReverse
        }
      >
        <main>
          <div className={classes.headerContent}>
            <div className={classes.headerText}>
              <Typography variant="body2" className={classes.modalTitle}>
                {modalContent.title}
              </Typography>
              <div className={classes.exitIcon}>
                <Clickable
                  className={classes.exitIcon}
                  onClick={() => {
                    setIsClosing(true);
                    setTimeout(() => {
                      setIsClosing(false);
                      onClose();
                    }, 750);
                  }}
                >
                  <Icon type="cross" />
                </Clickable>
              </div>
            </div>
            <div className={classes.subHeader}>
              <Typography variant="label1">{modalContent.content}</Typography>
            </div>
          </div>
          <div className={classes.modalImage}>
            <Auth0MockStaticLoginInstructions />
          </div>
        </main>
      </article>
    </section>
  );
};

export default Auth0Modal;
